import React from 'react'
import i18n from 'i18next'
import PropTypes from 'prop-types'
import Headline from '#components/a/Headline'
import FeedbackTable from '#components/m/Feedback/FeedbackTable'
import Text from '#components/a/Text'

function FeedbackOverview({feedbackList}) {
  const hasFeedback = feedbackList.length > 0

  return (
    <div>
      <Headline importance={2} modifier="category" text={i18n.t('feedback_overview')} />
      {hasFeedback ? (
        <FeedbackTable feedbackList={feedbackList} />
      ) : (
        <Text text={i18n.t('feedback_no_feedback_given_received')} />
      )}
    </div>
  )
}

FeedbackOverview.propTypes = {
  feedbackList: PropTypes.array,
}

export default FeedbackOverview
